import { AccountInfo } from "@/features/dashboard/components/AccountInfo";
import { PasskeyManager } from "@/components/commons/PasskeyManager";
import { PasskeySetupPrompt } from "@/features/dashboard/components/PasskeySetupPrompt";
import { ProductContract } from "@/features/dashboard/components/ProductContract";
import { UserCounting } from "@/features/dashboard/components/UserCounting";
import { Box, Stack } from "@mui/material";
import { FC } from "react";

export const DashboardPage: FC = () => {
  return (
    <Stack direction="row" gap="32px" alignItems="stretch">
      <Box flex={1}>
        <ProductContract />
      </Box>
      <Stack width="380px" gap="32px">
        <AccountInfo />
        <UserCounting />
        <PasskeyManager />
      </Stack>
      <PasskeySetupPrompt />
    </Stack>
  );
};
